"use client"
import ReactPaginate from "react-paginate"
import { updateQueryParams } from "@/utils/readingroom"

import { useState, useEffect, useRef } from "react"
import { useRouter } from "next/navigation"

import List from "@/components/Events/List/List"
import Intro from "@/components/Events/Intro/Intro"
import Container from "@/components/Container/Container"

export const revalidate = 60

export default function EventsPage({
  events,
  lastEvent,
  itemsPerPage,
  page = 1,
}) {
  const [items, setItems] = useState(events?.results)
  const [itemsCount, setItemsCount] = useState(events?.count)
  const [currentPage, setCurrentPage] = useState(page)
  const listRef = useRef(null)

  const router = useRouter()

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1)
    if (listRef.current) {
      listRef.current.scrollIntoView({
        behavior: "smooth",
      })
    }
  }

  useEffect(() => {
    if (currentPage == 1) {
      updateQueryParams({ page: false }, "/events/", router)
    } else {
      updateQueryParams({ page: currentPage }, "/events/", router)
    }
  }, [currentPage])

  const pageCount = Math.ceil(itemsCount / itemsPerPage)

  return (
    <>
      {lastEvent && <Intro item={lastEvent} />}
      {items?.length > 0 ? (
        <div
          className="events-page__container"
          style={{ position: "relative" }}
        >
          <List items={items} withPagination ref={listRef}></List>
          {itemsCount > itemsPerPage && (
            <ReactPaginate
              forcePage={currentPage - 1}
              className="pagination"
              breakLabel=""
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              nextLabel=""
              previousLabel=""
              renderOnZeroPageCount={null}
              previousLinkClassName="pagination__arrow pagination__arrow_prev"
              nextLinkClassName="pagination__arrow pagination__arrow_next"
              disabledLinkClassName="disabled"
              pageClassName="pagination__page"
              activeClassName="active"
            />
          )}
        </div>
      ) : (
        <Container>
          <div style={{ padding: "40px 0" }}>
            Events will be available soon.
          </div>
        </Container>
      )}
    </>
  )
}
